export const getDynamicMaxLength = (width: number): number => {
  let dynamicMaxLength = 100;

  if (width >= 375 && width <= 500) {
    dynamicMaxLength = 197;
  } else if (width >= 501 && width <= 600) {
    dynamicMaxLength = 251;
  } else if (width >= 601 && width <= 700) {
    dynamicMaxLength = 290;
  } else if (width >= 701 && width <= 830) {
    dynamicMaxLength = 322;
  } else if (width > 830 && width <= 1023) {
    dynamicMaxLength = 395;
  }

  return dynamicMaxLength;
};
